import axios from 'axios'
import { SAVE_MUTI_CART_API, LIST_MULTI_CART_API, CLEAR_MULTI_CART_API, DEL_MULTI_ROOM_API, EMIT_MUTI_CART_API, SAVE_MUTI_CART_BATCH_API } from '@api/url.api'

// 多人点餐服务API
export default class MultiPersonOrderingAPI {
  /**
   * 获取多人点餐服务数据
   * @param {IListMultiCartParams} params - 接口参数
   */
  static async getMultiCart (params: IListMultiCartParams): Promise<IListMultiCartRes> {
    const url = LIST_MULTI_CART_API
    const res = await axios.post(url, params).catch(err => {
      console.error('获取多人点餐数据失败:', err)
      return {
        error: true,
        errorMsg: '获取多人点餐数据失败'
      }
    }) as any
    console.log('res: getMultiCart', res)
    return res.error ? res : res.result
  }
  /**
   * 增删改多人点餐数据
   * @param {ISaveMultiCartParams} params - 接口参数
   */
  static async saveMultiCart (params: ISaveMultiCartParams): Promise<ISaveMultiCartRes> {
    const url = SAVE_MUTI_CART_API
    const res = await axios.post(url, params).catch(err => {
      console.error('设置多人点餐数据失败:', err)
      return {
        error: true,
        errorMsg: '设置多人点餐数据失败'
      }
    }) as any
    return res.error ? res : { result: res.result }
  }

  /**
   * 增删改多人点餐数据(批量)
   * @param {ISaveMultiCartParams} params - 接口参数
   */
  static async saveMultiCartBatch (params: ISaveMultiCartParams[]): Promise<ISaveMultiCartRes> {
    const url = SAVE_MUTI_CART_BATCH_API
    const res = await axios.post(url, params).catch(err => {
      console.error('设置多人点餐数据失败:', err)
      return {
        error: true,
        errorMsg: '设置多人点餐数据失败'
      }
    }) as any
    return res.error ? res : { result: res.result }
  }

  /**
   * 触发一个自定义的事件
   * @param 接口参数
   */
  static async emitMultiCart (params: IEmitMultiCartParams) {
    const url = EMIT_MUTI_CART_API
    const res = await axios.post(url, params).catch(err => {
      console.error('触发多人点餐数据失败:', err)
      return {
        error: true,
        errorMsg: '触发多人点餐数据失败'
      }
    }) as any
    return res.error ? res : { result: res.result }
  }
  /**
   * 清空多人点餐的餐品数据
   * @param {IClearMultiCartParams} params - 接口参数
   */
  static async clearMultiCart (params: IClearMultiCartParams): Promise<IClearMultiCartRes> {
    const url = CLEAR_MULTI_CART_API
    const res = await axios.post(url, params).catch(err => {
      console.error('清空数据失败:', err)
      return {
        error: true,
        errorMsg: '清空数据失败'
      }
    }) as any
    return res.error ? res : { result: res.result }
  }
  /**
  * 清空多人点餐房间
  */
  static async delMultiRoom (params: IDelMultiRoomParams): Promise<IDelMultiRoomRes> {
    const url = DEL_MULTI_ROOM_API
    const res = await axios.post(url, params).catch(err => {
      console.error('清空数据失败:', err)
      return {
        error: true,
        errorMsg: '清空数据失败'
      }
    }) as any
    return res.error ? res : { result: res.result }
  }
}
